// books / book_files 저장소 접근 (기획서 7.2, 7.3, 12.3.1 무결성)
import {
  idbGet,
  idbGetAll,
  idbPut,
  idbDelete,
  idbGetAllByIndex,
  idbWriteWithRetry,
} from './schema.js';

export async function getAllBooks() {
  const books = await idbGetAll('books');
  // lastReadAt 내림차순 (없으면 addedAt)
  books.sort((a, b) => (b.lastReadAt || b.addedAt) - (a.lastReadAt || a.addedAt));
  return books;
}

export async function getBook(bookId) {
  return idbGet('books', bookId);
}

export async function getBookFileBlob(bookId) {
  const rec = await idbGet('book_files', bookId);
  return rec ? rec.blob : null;
}

/**
 * 책 추가 (기획서 9.1 + 12.3.1):
 *  books 메타 저장 → book_files Blob 저장 순서.
 *  Blob 저장 최종 실패 시 방금 추가한 books 메타를 롤백 삭제 (부분 생성 방지).
 */
export async function addBook(meta, blob, initialProgress) {
  await idbWriteWithRetry(() => idbPut('books', meta));
  try {
    await idbWriteWithRetry(() => idbPut('book_files', { bookId: meta.id, blob }));
  } catch (err) {
    // 롤백: 메타만 있고 파일 없는 깨진 상태 방지
    try {
      await idbDelete('books', meta.id);
    } catch {
      /* 롤백 실패는 무결성 스캔이 처리 */
    }
    throw err;
  }
  await idbWriteWithRetry(() => idbPut('reading_progress', initialProgress));
  return meta;
}

export async function updateBook(meta) {
  return idbWriteWithRetry(() => idbPut('books', meta));
}

// 책 삭제 — 4개 스토어에서 일괄 제거
export async function deleteBook(bookId) {
  await idbDelete('books', bookId);
  await idbDelete('book_files', bookId);
  await idbDelete('reading_progress', bookId);
  const caches = await idbGetAllByIndex('page_cache', 'bookId', bookId);
  for (const c of caches) await idbDelete('page_cache', c.key);
}

/**
 * 앱 시작 시 정합성 스캔 (기획서 12.3.1).
 * books 의 모든 id 에 대해 book_files 존재 여부 확인.
 * 빠진 항목 id 배열을 반환 (자동 삭제하지 않음 — 사용자 확인 우선).
 */
export async function scanIntegrity() {
  const books = await idbGetAll('books');
  const files = await idbGetAll('book_files');
  const fileIds = new Set(files.map((f) => f.bookId));
  return books.filter((b) => !fileIds.has(b.id)).map((b) => b.id);
}
